<template>
  <div>
    <b-row class="ml-0">
      <div class="mb-3">
        <b-button class="my-collapse " v-b-toggle.my-collapse variant="primary"> 

          <feather-icon icon="FilterIcon" size="12" :class="'text-white'" />
          {{ $t('Filters') }}
        </b-button>

      </div>
      <br />
      <div v-if="showDateTime" class="col-md-8">

        <h4>
          <date-time-widget />
        </h4>
      </div>
    </b-row>
    <b-collapse id="my-collapse">
      <b-card>


        <slot></slot>




      </b-card>
    </b-collapse>


  </div>
</template>
<script>

import Vue from 'vue';

import DateTimeWidget from '@/views/widgets/DateTimeWidget.vue'
import {
  VBToggle, BCollapse, BButton, BCard, BIcon, BRow
} from 'bootstrap-vue'

Vue.directive('b-toggle', VBToggle)
export default {

  name: 'ToggaleCollabsable',
  props: ["showDateTime"],
  components: {
    BButton, BCard, BCollapse, VBToggle, BIcon, BRow, DateTimeWidget

  },



}
</script>
<style scoped>
.my-collapse {
  margin-bottom: -25px;
  z-index: 9999;


}
</style>